import factory from 'theme/base/base';
import lightColors from 'theme/colors/light.json';
import constants from 'helpers/constants';
import colors from 'helpers/colors';
import system from 'helpers/system';

const palette = colors.createPalette(lightColors);

let themeOverrides = {
  name: 'light',
  palette: {
    mode: 'light',
    ...palette,
    menuButton: {
      states: {
        defaultText: (theme) => theme.property('palette.blueGrey.600')
      }
    }
  },
  components: {
    // MuiButtonBase: {
    //   styleOverrides: {
    //     // Name of the slot
    //     root: {
    //       // Some CSS
    //       // fontSize: '3.4rem',
    //     },
    //   },
    // }
  },
  mixins: {
    // Button: css`
    //   &.Button-light {
    //     &.MuiButton-outlined {
    //       border-color: ${props => darken(props.theme.property('palette.tonalOffset'), props.theme.property('palette.grey.300'))};
    //     }
    //   }
    // `,
  },
};

const whiteLabel = system.whiteLabel();
if (whiteLabel) {
  const whiteLabelDef = constants.data.lookup('whiteLabels', whiteLabel)
  if (whiteLabelDef?.factories?.theme?.light) {
    themeOverrides = whiteLabelDef.factories.theme.light(themeOverrides);
  }
}

const themeLight = factory(themeOverrides);

export default themeLight;

